import { typography } from "./dark-theme-options";

const neutral = {
  100: "#F3F4F6",
  200: "#E5E7EB",
  300: "#D1D5DB",
  400: "#9CA3AF",
  500: "#6B7280",
  600: "#4B5563",
  700: "#374151",
  800: "#1F2937",
  900: "#111827",
};

const divider = "#E6E8F0";

const colors = {
  origin: {
    main: "rgb(204 219 253)",
  },
  background: {
    main: "#e2eafc",
    paper: "#ccdbfd",
    login: "#ccdbfd14"
  },
  edit: {
    main: "#e2eafc",
  },
  text: {
    main: "rgb(33, 43, 54)",
  },
  primary: {
    main: "#487cb1",
  },
  inactive: {
    main: "rgb(244, 246, 248)",
  },
  darkGray: {
    main: "rgb(99, 115, 129)",
  },
  lightGray: {
    main: "rgb(33, 43, 54)",
  },
  warning: {
    main: "rgb(183, 129, 3)",
  },
  error: {
    main: "rgb(183, 33, 54)",
  },
  success: {
    main: "rgb(34, 154, 22)",
  },
  card: {
    main: "#edf2fb",
  },
};

export const lightThemeOptions = {
  components: {
    MuiButton: {
      variants: [
        {
          props: {
            variant: "primary",
          },
          style: {
            backgroundColor: colors.background.main,
            color: colors.primary.main,
            boxShadow: "rgb(32 101 209 / 24%) 0px 10px 16px 0px",
            "&:hover": {
              backgroundColor: "rgb(16, 57, 150)",
              boxShadow: "none",
            },
          },
        },
        {
          props: {
            variant: "error",
          },
          style: {
            backgroundColor: colors.background.main,
            color: colors.primary.main,
            "&:hover": {
              backgroundColor: colors.background.paper,
            },
          },
        },
      ],
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          ":hover": {
            transform: "scale(1.1)",
            transition: "150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
          },
        },
      },
    },

    MuiTableHead: {
      styleOverrides: {
        root: {
          "&.MuiTableHead-root ": {
            backgroundColor: colors.inactive.main,
          },
          ".MuiTableCell-root.MuiTableCell-head": {
            color: colors.darkGray.main,
            textTransform: "capitalize",
          },
          ".MuiTableCell-root.MuiTableCell-head:first-of-type": {
            borderRadius: "10px 0 0 10px",
          },
          ".MuiTableCell-root.MuiTableCell-head:last-of-type": {
            borderRadius: "0 10px 10px 0",
          },
        },
      },
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          ".MuiTableCell-root.MuiTableCell-body": {
            color: colors.text.main,
            borderBottom: "none",
          },
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          backgroundColor: neutral[500],
          color: "#FFFFFF",
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(238, 238, 238,0.2)",
        },
      },
    },

    MuiFormHelperText: {
      styleOverrides: {
        root: {
          "&.MuiFormHelperText-root": {
            color: colors.primary.main,
            marginLeft: "0",
          },
          "&.MuiFormHelperText-root.Mui-error": {
            color: "#C62828",
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          "&::placeholder": {
            opacity: 1,
            color: colors.text.secondary,
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          // borderColor: divider,
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          borderColor: divider,
          borderStyle: "solid",
          borderWidth: 1,
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          borderColor: divider,
          borderStyle: "solid",
          borderWidth: 1,
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          color: neutral[500],
        },
        track: {
          backgroundColor: neutral[400],
          opacity: 1,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          textTransform: "capitalize",
          textAlign: "center",
          borderBottom: `1px solid ${divider}`,
        },
      },
    },
    //for table heade
    // MuiTableHead: {
    //   styleOverrides: {
    //     root: {
    //       backgroundColor: "inherit",

    //       ".MuiTableCell-root": {
    //         borderBottom: `1px solid ${divider}`,
    //         color: "#212121",
    //         textTransform: "capitalize",
    //       },
    //     },
    //   },
    // },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          backgroundColor: "rgb(237, 231, 246)",
        },
      },
    },
    // MuiPagination: {
    //   styleOverrides: {
    //     root: {
    //       "& .MuiPaginationItem-root": {
    //         "&:hover": {
    //           backgroundColor: "rgba(255, 255, 255, 0.08)",
    //           transition: "250ms",
    //         },
    //         color: "#616161",
    //         backgroundColor: "inherit",
    //         "&.Mui-selected ": {
    //           color: "#ffffff",
    //           backgroundColor: "#2196F3",
    //         },
    //       },
    //     },
    //   },
    // },
    // MuiDialog: {
    //   styleOverrides: {
    //     root: {
    //       ".MuiDialog-container .MuiPaper-root": {
    //         boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    //         borderRadius: 8,
    //         width: "35%", // this one will be deleted in the end
    //       },
    //     },
    //   },
    // },
    MuiDialog: {
      styleOverrides: {
        root: {
          ".MuiDialog-container .MuiPaper-root": {
            backgroundColor: colors.background.main,
            borderRadius: 8,
            width: "35%", // this one will be deleted in the end
            zIndex: "1200",
          },
        },
      },
    },
  },

  palette: {
    mode: "light",
    ...colors,
  },
  typography: {
    ...typography,
  },
};
